import { routeMiddleware } from '@/router/middlewares/types/routeMiddleware';
import { useRouterHelperStore } from '@/stores/RouterHelper';

export const saveBackRoutes: routeMiddleware = ({ to, from, next }) => {
  useRouterHelperStore().saveBackRoute(to, from);
  return next();
};
